export const ExpenseTableConfig: NeoTableConfig = {
  title: "Expenses",
  table: {
    columns: [],
    activeColumns: [],
    style: {height: "h-full"},
    meta: {
      id: 6,
      title: "",
      description: "Total Data",
      hasSearch: false,
      hasUpload: false,
      hasDownload: true,
      hasAdd: false,
      hasActions: false,
      hasCheckbox: false,
      hasFilter: false,
      hasFooter: true,
      hasHeader: true,
      hasPagination: true,
      hasCreate: true
    },
    url: {page: {}, api: {}},
    actions: [
      {key: "view", label: "View", type: "modal", isVisible: false},
      {key: "edit", label: "Edit", type: "modal", isVisible: true},
      {key: "delete", label: "Delete", type: "modal", isVisible: true}
    ]
  }
};
